import React from "react";
import styles from "./form.css";

export const InputGroup = (props: { children?: JSX.Element | Array<JSX.Element> }) => (
  <div className={styles["input-group"]}>{props.children}</div>
);
